import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { getToken } from "./utils/authStorage";

Vue.config.productionTip = false;
axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api`;

let token = getToken();
axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

const options = {
  position: "bottom-right",
  timeout: 3000,
  closeOnClick: false,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: false,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: true,
};

Vue.use(Toast, options);

import Echo from "laravel-echo";
import Pusher from "pusher-js";

if (process.env.VUE_APP_PUSHER_LOG == "active") {
  Pusher.logToConsole = true;
}

if (process.env.VUE_APP_PUSHER_KEY && process.env.VUE_APP_PUSHER_KEY !== "") {
  window.Pusher = Pusher;
  window.Echo = new Echo({
    broadcaster: "pusher",
    wsHost: process.env.VUE_APP_API_URL,
    wsPort: 8000,
    disableStats: true,
    authEndpoint: process.env.VUE_APP_API_URL + "/broadcasting/auth",
    broadcaster: "pusher",
    key: process.env.VUE_APP_PUSHER_KEY,
    cluster: process.env.VUE_APP_PUSHER_CLUSTER,
    forceTLS: true,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });

  window.Echo.join("online")
    .here((users) => {
      var list = [];
      users.forEach((user) => {
        list.push(user.id);
      });
      store.state.online_users = list;

      var list2 = [];
      users.forEach((user) => {
        list2.push(user);
      });
      store.state.online_users_full = list2;
    })
    .joining((user) => {
      store.state.online_users.push(user.id);
      store.state.online_users_full.push(user);
    })
    .leaving((user) => {
      store.state.online_users.splice(
        store.state.online_users.indexOf(user.id)
      );
      store.state.online_users_full.splice(
        store.state.online_users_full.indexOf(user)
      );
    });
}

import { VueReCaptcha } from "vue-recaptcha-v3";

if (process.env.VUE_APP_CAPCHA_SITE_KEY != "") {
  Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_CAPCHA_SITE_KEY,
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
